import {
  Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy, OnChanges, SimpleChanges
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApeDrawerComponent } from "../ape-drawer/ape-drawer.component";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";
import { LoggerService } from "../../../ancestors/logger.service";
import { SvgIconComponent } from "angular-svg-icon";

/**
 * Componente sidenav per la sezione supporto.
 * Mostra i testi della pagina di supporto della piattaforma attuale di Cigierre
 * (informazioni utili, riferimento email per l'assistenza, guida pratica al
 * Performance Management e informativa privacy dipendenti).
 */
@Component({
  selector: "ape-support-sidenav",
  standalone: true,
  imports: [
    CommonModule,
    ApeDrawerComponent,
    TranslatePipe,
    SvgIconComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./ape-support-sidenav.component.html"
})
export class ApeSupportSidenavComponent implements OnChanges {
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  private logger = inject(LoggerService);

  /**
   * Visibilità del drawer
   */
  @Input() visible = false;

  /**
   * Diventa vero alla prima apertura e resta tale: il contenuto si crea a lingua già impostata e non sparisce
   * durante l'animazione di chiusura
   */
  contentReady = false;

  /**
   * Evento di cambio visibilità
   */
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor() {
    this.logger.setCaller(this.constructor.name);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.visible?.currentValue) {
      this.contentReady = true;
    }
  }

  /**
   * Gestisce il cambio di visibilità del drawer
   */
  onVisibleChange(visible: boolean): void {
    this.visible = visible;
    if (visible) {
      this.contentReady = true;
    }
    this.visibleChange.emit(visible);
  }
}
